// Generated by purs version 0.15.15
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
var fromFoldable = /* #__PURE__ */ Foreign_Object.fromFoldable(Data_Foldable.foldableArray);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var enumConstructorsConstruct = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    return {
        enumConstructors: function (construct) {
            return function (opts) {
                return [ new Data_Tuple.Tuple(opts.constructorTagTransform(reflectSymbol(Type_Proxy["Proxy"].value)), construct(Data_Generic_Rep.NoArguments.value)) ];
            };
        }
    };
};
var enumConstructors = function (dict) {
    return dict.enumConstructors;
};
var genericUnsafeDecodeEnum = function (dictGeneric) {
    var to = Data_Generic_Rep.to(dictGeneric);
    return function (dictEnumConstructors) {
        var enumConstructors1 = enumConstructors(dictEnumConstructors);
        return function (opts) {
            var constructors = fromFoldable(enumConstructors1(to)(opts));
            return function (value) {
                var tag = Unscramble.decodeString(value);
                var v = Foreign_Object.lookup(tag)(constructors);
                if (v instanceof Data_Maybe.Nothing) {
                    return Unscramble.decodingError("Invalid enum tag value: " + show(tag));
                };
                if (v instanceof Data_Maybe.Just) {
                    return v.value0;
                };
                throw new Error("Failed pattern match at Unscramble.Enum (line 19, column 5 - line 23, column 10): " + [ v.constructor.name ]);
            };
        };
    };
};
var enumConstructorsSum = function (dictEnumConstructors) {
    var enumConstructors1 = enumConstructors(dictEnumConstructors);
    return function (dictEnumConstructors1) {
        var enumConstructors2 = enumConstructors(dictEnumConstructors1);
        return {
            enumConstructors: function (construct) {
                return function (opts) {
                    return append1(enumConstructors1(function ($22) {
                        return construct(Data_Generic_Rep.Inl.create($22));
                    })(opts))(enumConstructors2(function ($23) {
                        return construct(Data_Generic_Rep.Inr.create($23));
                    })(opts));
                };
            }
        };
    };
};
var defaultEnumOptions = {
    constructorTagTransform: /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn)
};
export {
    enumConstructors,
    genericUnsafeDecodeEnum,
    defaultEnumOptions,
    enumConstructorsConstruct,
    enumConstructorsSum
};
